;(function() {
  'use strict'

  Controller.$inject = ["$window", "glToast", "assetService", "uacService"];
  angular.module('app.core').component('projectResourceCard', {
    controller: Controller,
    templateUrl: 'project-resource-card.html',
    bindings: {
      resource: '<',
      layout: '@',
      onEdit: '&?',
      onDelete: '&?',
    },
  })

  /* @ngInject */
  function Controller($window, glToast, assetService, uacService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.click = click
    ctrl.getHref = getHref
    ctrl.getIcon = getIcon
    ctrl.getInfo = getInfo
    ctrl.getMenuItems = getMenuItems

    function onInit() {
      ctrl.canManage = uacService.canManageProjects()
    }

    function onChanges() {
      ctrl.isRow = ctrl.layout === 'row'
    }

    function getHref() {
      return ctrl.resource.isLink() ? ctrl.resource.url : undefined
    }

    function getIcon() {
      return ctrl.resource.isLink() ? 'link' : 'file-download'
    }

    function getInfo() {
      return ctrl.resource.isLink() ? ctrl.resource.url : getFilename()
    }

    function getFilename() {
      var asset = ctrl.resource.asset
      return (asset && asset.filename) || ''
    }

    function click() {
      if (ctrl.resource.isFile()) open()
    }

    function open() {
      var resource = ctrl.resource
      if (resource.isLink()) {
        $window.open(resource.url, '_blank')
        return
      }
      assetService
        .download(
          resource.asset.id,
          'Download File',
          'You are downloading ' + resource.name + '.'
        )
        .catch(function(error) {
          console.error(error)
          glToast.show('There was an error downloading this file.')
        })
    }

    function getMenuItems() {
      return [
        { text: ctrl.resource.isLink() ? 'Open' : 'Download', onClick: open },
        ctrl.canManage && ctrl.onEdit && { text: 'Edit', onClick: ctrl.onEdit },
        ctrl.canManage &&
          ctrl.onDelete && {
            text: 'Delete',
            onClick: ctrl.onDelete,
            last: true,
            danger: true,
          },
      ]
    }
  }
})()
